import { RefreshCcwIcon } from 'lucide-react';

const Spinner = () => (
  <RefreshCcwIcon className="animate-spin text-4xl text-blue-800" />
);

export default Spinner;
